export const HOMEPAGE = {
  section_name: 'homepage',
  cohort: 'financial_clarity',
  entity_names: {
    tabs: 'vertical_comparison_tab',
    primary_cta: 'primary_cta_button',
    secondary_cta: 'secondary_cta_button',
    registration: 'registration_module',
    testimonials: 'testimonials_module',
    cc_best: 'best_credit_card_module',
    campaign: 'campaign_module',
    auth_buttons: 'auth_button',
    success: 'success_modal',
    error: 'error_modal',
  },
  trk: {
    trk_location: 'homepage',
    trk_format: 'financial_clarity',
  },
};
